import { Badge } from '@commenda/kakashi';
import { classNames } from '@commenda/utils';
import { WorkflowStepDescription } from '../../../components';
import { IncorporationRequestStatus } from '@prisma/client';
import { WorkflowProcessDrawerParentSteps } from './types';

const WorkflowProcessParentStep = ({
  isActive,
  step,
  onClick,
}: {
  isActive: boolean;
  step: WorkflowProcessDrawerParentSteps;
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'border-r-[6px] py-4 px-5 hover:bg-bg-primary-hover transition cursor-pointer flex flex-col gap-2 border-b border-b-border-primary',
        isActive
          ? 'border-fg-tertiary bg-bg-primary-hover'
          : 'border-[rgba(0,0,0,0)] bg-bg-primary'
      )}
    >
      <div className="flex items-center justify-between">
        <span
          className={classNames(
            isActive
              ? 'txt-medium-bold text-text-primary'
              : 'text-text-primary',
            'mr-4'
          )}
        >
          {step.heading}
        </span>
        {step.status && (
          <Badge
            variant={
              step.status === IncorporationRequestStatus.Completed
                ? 'success'
                : 'gray'
            }
          >
            {step.status === IncorporationRequestStatus.Completed
              ? 'Completed'
              : 'Not Started'}
          </Badge>
        )}
      </div>
      <WorkflowStepDescription
        description={step.description}
        className="text-text-secondary txt-small-regular mt-1"
      />
    </div>
  );
};

export { WorkflowProcessParentStep };
